<template>
  <div class="combobox-rental-mutation-or-rental-mutation-item-display">
    <ComboboxRentalIntakeItemDisplay
      v-if="itemOrTransaction instanceof RentalIntakeItem"
      :item="itemOrTransaction"
      :flow-direction="flowDirection"
      :show-badge="showBadge"
    />
    <ComboboxRentalDispenseItemDisplay
      v-else-if="itemOrTransaction instanceof RentalDispenseItem"
      :item="itemOrTransaction"
      :flow-direction="flowDirection"
      :show-badge="showBadge"
    />
    <ComboboxRentalIntakeDisplay
      v-else-if="itemOrTransaction instanceof RentalIntake"
      :item="itemOrTransaction"
      :flow-direction="flowDirection"
      :is-list-item="isListItem"
      :is-being-updated="isBeingUpdated"
      :show-date="showDate"
      :show-project="showProject"
      :show-badge="showBadge"
      :show-counter-booking="showCounterBooking"
      :show-error="showError"
      :error="Array.isArray(error) ? error[0] : error"
      @clear-error="$emit('clearError')"
    />
    <ComboboxRentalDispenseDisplay
      v-else
      :item="itemOrTransaction"
      :flow-direction="flowDirection"
      :is-list-item="isListItem"
      :show-date="showDate"
      :show-project="showProject"
      :show-badge="showBadge"
      :show-counter-booking="showCounterBooking"
      :show-error="showError"
      :error="Array.isArray(error) ? error[0] : error"
      :is-being-updated="isBeingUpdated"
      @clear-error="$emit('clearError')"
    />
  </div>
</template>

<script setup lang="ts">
import { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import type { RentalMutationFlowDirections } from "@/enums/rental-mutation-flow-directions"
import { RentalDispense } from "@/models/rental-dispense.model"
import { BaseException } from "@/exceptions/base-exception.exception"
import ComboboxRentalDispenseItemDisplay from "@/components/administration/combobox-display-templates/ComboboxRentalDispenseItemDisplay.vue"
import ComboboxRentalDispenseDisplay from "@/components/administration/combobox-display-templates/ComboboxRentalDispenseDisplay.vue"
import ComboboxRentalIntakeItemDisplay from "@/components/administration/combobox-display-templates/ComboboxRentalIntakeItemDisplay.vue"
import { RentalIntakeItem } from "@/models/rental-intake-item.model"
import { RentalIntake } from "@/models/rental-intake.model"
import ComboboxRentalIntakeDisplay from "@/components/administration/combobox-display-templates/ComboboxRentalIntakeDisplay.vue"
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    item:
      | RentalIntakeItem
      | RentalDispenseItem
      | RentalIntake
      | RentalDispense
      | [RentalIntake]
      | [RentalDispense]
    flowDirection: RentalMutationFlowDirections
    isListItem?: boolean
    isBeingUpdated?: boolean
    showDate?: boolean
    showProject?: boolean
    showBadge?: boolean
    showCounterBooking?: boolean
    showError?: boolean
    error?: BaseException | BaseException[]
  }>(),
  {
    isListItem: false,
    isBeingUpdated: false,
    showDate: true,
    showProject: true,
    showBadge: true,
    showCounterBooking: true,
    showError: true
  }
)

defineEmits(["clearError"])

const itemOrTransaction = computed(() => {
  if (
    props.item instanceof RentalIntakeItem ||
    props.item instanceof RentalDispenseItem ||
    props.item instanceof RentalIntake ||
    props.item instanceof RentalDispense
  ) {
    return props.item
  }
  return props.item[0]
})
</script>

<style scoped></style>
